module.exports = __webpack_public_path__ + "static/veri-analizi-be49c5a9ceaf563a26bd8064b3d56da1.jpg";